// extracted by mini-css-extract-plugin
export default {"widget-header":"subscriptionrenewal_widget-header__Ou5pp","widget-body":"subscriptionrenewal_widget-body__ZdUMR","dropdown-disabled":"subscriptionrenewal_dropdown-disabled__W2ret"};